
export default {
  name: 'Banner',
  props: {
    countryCode: {
      type: String,
      default: null
    },
    company: {
      type: String,
      default: 'AirProducts'
    }
  }
}
